import { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

export type EndMessageProps = {
    message: ReactNode;
};

const EndMessage = ({ message }: EndMessageProps) => {
    const { theme } = useTheme();

    return (
        <Box
            sx={{
                flexDirection: 'row',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
                mb: 5.75,
                mt: 5.625,
            }}>
            <Typography
                variant="h6"
                component="p"
                sx={{
                    textAlign: 'center',
                    color: theme.palette.text.secondary,
                }}>
                {message}
            </Typography>
        </Box>
    );
};

export default EndMessage;
